import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTitle } from "../../../../hooks/useTitle";
import { withAuth } from "../../../../components/HOC/withAuth";
import CardContainer from "../../../../components/CustomUI/CardContainer";
import {
  KpiCard,
  SectionSpinner,
  SectionEmpty,
  exportXLSX,
} from "../shared/utils";
import { useDeliveriesReport } from "./useDeliveriesReport";
import DeliveriesReportShell from "./DeliveriesReportShell";
import { FiDownload } from "react-icons/fi";
import Button from "../../../../components/BaseUI/Button";

const DeliveriesTrendReport = () => {
  useTitle("Rovion MES - Aylık Teslimat");
  const {
    years,
    year,
    handleYearChange,
    deliveriesData,
    loading,
    derived,
    toasts,
    dismissToast,
  } = useDeliveriesReport();

  const content = () => {
    if (loading) return <SectionSpinner />;
    if (!deliveriesData || !derived)
      return <SectionEmpty msg="Teslimat verisi bulunamadı." />;

    const { labels, totalSeries } = derived;
    const cm = deliveriesData.currentMonth || {};
    const pm = deliveriesData.previousMonth || {};

    const totalBarChart = {
      series: [{ name: "Teslim Edilen Ürün", data: totalSeries }],
      options: {
        chart: { type: "bar", toolbar: { show: false }, fontFamily: "inherit" },
        plotOptions: { bar: { borderRadius: 4, columnWidth: "55%" } },
        dataLabels: { enabled: false },
        xaxis: {
          categories: labels,
          labels: { rotate: -30, style: { fontSize: "11px" } },
        },
        yaxis: { labels: { formatter: (v) => Math.round(v) } },
        colors: ["#2E75B6"],
        grid: { borderColor: "#e9ecef" },
        tooltip: { y: { formatter: (v) => `${v} adet` } },
      },
    };

    const exportRows = labels.map((lbl, i) => ({
      Ay: lbl,
      "Toplam Ürün": totalSeries[i],
    }));

    return (
      <>
        <CardContainer>
          <div className="d-flex justify-content-between align-items-center mb-2 p-2">
            <h5 className="mb-0">Aylık Teslimat ({year})</h5>
            <Button
              size="sm"
              appearance="subtle"
              onClick={() => exportXLSX(exportRows, `teslimat-trendi-${year}`)}
            >
              <FiDownload size={14} className="me-1" /> Excel
            </Button>
          </div>
          <ReactApexChart
            options={totalBarChart.options}
            series={totalBarChart.series}
            type="bar"
            height={300}
          />
        </CardContainer>
      </>
    );
  };

  return (
    <DeliveriesReportShell
      title="Aylık Teslimat"
      year={year}
      years={years}
      onYearChange={handleYearChange}
      toasts={toasts}
      dismissToast={dismissToast}
    >
      {content()}
    </DeliveriesReportShell>
  );
};

export default withAuth(DeliveriesTrendReport);
